const VSF_COUNTRY_COOKIE = 'vsf-country';
const VSF_LOCALE_COOKIE = 'vsf-locale';

export default defineNuxtPlugin(async (nuxtApp) => {
  const { $i18n, $config } = useNuxtApp();
  const route = useRoute();
  const { hostname } = import.meta.test ? { hostname: 'shop.kik.local.de' } : useRequestURL();
  const domainsConfig: CountryConfig[] = [
    ...Object.values($config.public.markets),
    ...Object.values($config.public.kiosks),
  ];

  const checkDomain = (hostname: string) => domainsConfig.find(element => hostname.includes(element.host));
  const domainConfig = checkDomain(hostname);

  try {
    if (!domainConfig) {
      throw new Error(`Host "${hostname}" could not be mapped to a country domain.`);
    }

    const VSF_COUNTRY = useCookie(VSF_COUNTRY_COOKIE);
    VSF_COUNTRY.value = domainConfig.countryCode;
    const VSF_LOCALE = useCookie(VSF_LOCALE_COOKIE);
    VSF_LOCALE.value = domainConfig.locales[0];

    const authoringMode = route.query.mgnlPreview !== undefined;

    if (!domainConfig.locales?.includes($i18n.locale.value) && !authoringMode) {
      await $i18n.setLocale(domainConfig.locales?.[0] as ('de-DE' | 'de-AT' | 'pl-PL' | 'pt-PT' | 'es-ES' | 'it-IT' | 'nl-NL' | 'cs-CZ' | 'sk-SK' | 'hu-HU' | 'sl-SI' | 'hr-HR' | 'ro-RO' | 'bg-BG') ?? 'de-DE');
    }

    nuxtApp.provide('domain', domainConfig);
  }
  catch (err) {
    console.error('Failed to check domain.', err);
  }
});
